const easingFunctions = { linear: (v) => v };

const getTimeline = (animationGroup, totalDelay = 0) => {
    const {delay = 0, type, animations = []} = animationGroup;
    if (type === 'serial') return animations.reduce(({timelines, delaySum}, animation) => ({
        timelines: timelines.concat(...getTimeline(animation, delaySum)),
        delaySum: delaySum + animation.duration
    }), {delaySum: delay + totalDelay, timelines: []}).timelines;
    if (animations.length) return animations.flatMap(
        (animation) => getTimeline(animation, delay + totalDelay)
    );
    return [{ ...animationGroup, delay: totalDelay }];
};

const getValue = (anim, elapsed) => {
    const {delay, from, to, duration, easing = 'linear'} = anim;
    const normalised = Math.max(0, Math.min(1, (elapsed - delay) / duration));
    const eased = easingFunctions[easing](normalised);
    return from + eased * (to - from);
};

const animate = (animationGroup, update) => {
    let startTime;
    let elapsed = 0;
    let playing = false;
    const timeline = getTimeline(animationGroup);
    const maxDuration = Math.max(...timeline.map((t) => t.delay + t.duration));

    const playNextFrame = (ms) => {
        startTime ??= ms;
        if (playing) {
            requestAnimationFrame(playNextFrame);
            elapsed = ms - startTime;
            update(timeline.reduce((soFar, anim) => ({
                ...soFar,
                [anim.field]: getValue(anim, elapsed)
            }), {}));
            if (elapsed >= maxDuration) playing = false;
        }
    };
    return () => { playing = true; requestAnimationFrame(playNextFrame); };
};

export default animate;
